require('./periodicLoadsFilter.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText, getLanguage } = require('core/i18n').i18n;

// @components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKModal = require('components/commons/OKModal/OKModal');

// @commons
const { AmountFilter } = require('commonsComponents/amountFilter');
const {
    AMOUNT_FILTER_LABEL,
    AMOUNT_FILTER_GREATER_THAN,
    AMOUNT_FILTER_LOWER_THAN
} = require('constants/commonsComponents');

// @constants
const { EURO_SYMBOL } = require('constants/index');
const { getTypesOfPeriodicityOptions } = require('constants/cardPeriodicLoads');


class PeriodicLoadsFilter extends React.Component {
    constructor(props) {
        super(props);
        const { immFilters } = props;
        this.state = {
            periodicity: immFilters.getIn(['periodicity', 'periodicity']),
            maxAmount: immFilters.getIn(['amount', 'maxAmount']),
            minAmount: immFilters.getIn(['amount', 'minAmount'])
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
    }

    handleFormSubmit(event) {
        event.preventDefault();
        const { onFilterSubmit, onCloseClick } = this.props;
        const { maxAmount, minAmount, periodicity } = this.state;

        onFilterSubmit({
            amount: {
                maxAmount,
                minAmount
            },
            periodicity: {
                periodicity
            }
        });
        onCloseClick();
    }

    handleTypeChange(value) {
        this.setState({
            periodicity: value.value
        });
    }

    handleChangeAmountMax(maxAmount) {
        this.setState({
            maxAmount
        });
    }

    handleChangeAmountMin(minAmount) {
        this.setState({
            minAmount
        });
    }

    render() {
        const { isOpen, onCloseClick } = this.props;
        const { maxAmount, minAmount, periodicity } = this.state;
        const periodicitiesOptions = getTypesOfPeriodicityOptions();

        const content = (
            <section className="periodic-loads-filter">
                <fieldset className="periodic-loads-filter__fieldset-amount">
                    <AmountFilter
                        amountLabel={AMOUNT_FILTER_LABEL}
                        currencySymbol={EURO_SYMBOL}
                        fromValue={minAmount}
                        greaterThan={AMOUNT_FILTER_GREATER_THAN}
                        language={getLanguage()}
                        lowerThan={AMOUNT_FILTER_LOWER_THAN}
                        onChangeMax={this.handleChangeAmountMax}
                        onChangeMin={this.handleChangeAmountMin}
                        toValue={maxAmount}
                    />
                </fieldset>
                <fieldset className="periodic-loads-filter__fieldset-periodicity">
                    <h3 className="periodic-loads-filter__periodicity-title">
                        <FormattedText value="cardPeriodicLoads-periodicity" />
                    </h3>
                    <div className="periodic-loads-filter__select-wrapper">
                        <OKSelect
                            clearable={false}
                            name="periodic-loads-filter-dropdown"
                            onChange={this.handleTypeChange}
                            openUp={true}
                            options={periodicitiesOptions}
                            searchable={false}
                            value={periodicity}
                        />
                    </div>
                </fieldset>
            </section>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="cardPeriodicLoads-filterTitle"
                type="filter"
            />
        )
    }
}

PeriodicLoadsFilter.propTypes = {
    immFilters: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onFilterSubmit: PropTypes.func,
}
module.exports = PeriodicLoadsFilter;
